// middleware/purgeMiddleware.js
import { signOut } from '../features/authentication/authenticationSlice';
import { persistor } from '../store';
import { clearClientAuthStorage } from '../utils/tabCloseLogout';

const purgeMiddleware = (store) => (next) => (action) => {
    if (action.type === signOut.type) {
        clearClientAuthStorage();
        persistor.purge();
    }
    return next(action);
};

export default purgeMiddleware;
